import { isCanlan } from './customer-name'

/* Felipe Nunes: Updated Fri, 18 Jul 2025 01:05 AM ( BRT ) */
// If it fails (like if the previously set hardcoded token is expired)
// try setting the hardcoded token again (hopefully a new one)
// {
//   "access_token": "v2.local.ZR8Qsz5BV_6pU-a_ZVgPK5GsTJgKTF3c9lK2SfLEegkM5tVSVkYRzWyqzEqm3cTULWvCIvS6jTmII2NrRQirP8iMcjyR5jgYdh34N9rACIP2qj-hr57z5D0Uf7-ZgqIIbcVhmclbCFsFqDKIuZbBpGprxd3oHd7lYa8qZIrr6H4eeQAamPgAFiafGGYVXjHWRg4TMK6OJLDsHfOM7-dyvK-dIvZfsEko56fVOFtTimxiasn4cHAXDflsFzcIwOwQSAwiTcaK4Anu7rpMzKXacOatH1j_Umc",
//   "token_type": "Bearer",
//   "expires_in": 604800,
//   "expires_at": "2025-07-25T04:05:13.493458Z",
//   "user": {
//     "id": "TAcc3KT6ikeaqhvL",
//     "email": "michael+planeticeservice@sportninja.com",
//     "created_at": "2022-08-29T23:14:34+00:00",
//     "updated_at": "2025-07-18T04:05:10+00:00",
//     "validated_at": "2022-08-29T23:14:42+00:00"
//   }
// }
const planetIceToken =
  'v2.local.ZR8Qsz5BV_6pU-a_ZVgPK5GsTJgKTF3c9lK2SfLEegkM5tVSVkYRzWyqzEqm3cTULWvCIvS6jTmII2NrRQirP8iMcjyR5jgYdh34N9rACIP2qj-hr57z5D0Uf7-ZgqIIbcVhmclbCFsFqDKIuZbBpGprxd3oHd7lYa8qZIrr6H4eeQAamPgAFiafGGYVXjHWRg4TMK6OJLDsHfOM7-dyvK-dIvZfsEko56fVOFtTimxiasn4cHAXDflsFzcIwOwQSAwiTcaK4Anu7rpMzKXacOatH1j_Umc'

// {
//   "access_token": "v2.local.F16xl8YwuaFm7tPwGjdCrMHYFPDhYA6lkguywHaLy394CaUgLlC_oLZI6mJVZtoOf_h2DsPYitlnOa0yKiVaQTDDS2bCNsr5cfLihrUMXzswj_wDHjd-Al_b-qCrF4P2kkn5jja9HfkKGk_OBoqpit8c26cppANMSNEf9E-Yx4LNH2TEnVPZdYD4bmPWra2H5VD2d_c2NEQpRJY9mllIhAJQhd3QrV-y2AOsZxOHOjZ4FBBLB_gkkgEYLmLxHh64i8WIrTAL_turWlVhF77gCXNLM_uh-fI",
//   "token_type": "Bearer",
//   "expires_in": 604800,
//   "expires_at": "2025-07-25T04:07:16.092797Z",
//   "user": {
//     "id": "oP37ysYCd57bFlkj",
//     "email": "michael+carhaservice@sportninja.com",
//     "created_at": "2022-05-27T18:35:59+00:00",
//     "updated_at": "2025-07-18T04:07:12+00:00",
//     "validated_at": "2022-05-27T18:35:59+00:00"
//   }
// }
const carhaToken =
  'v2.local.F16xl8YwuaFm7tPwGjdCrMHYFPDhYA6lkguywHaLy394CaUgLlC_oLZI6mJVZtoOf_h2DsPYitlnOa0yKiVaQTDDS2bCNsr5cfLihrUMXzswj_wDHjd-Al_b-qCrF4P2kkn5jja9HfkKGk_OBoqpit8c26cppANMSNEf9E-Yx4LNH2TEnVPZdYD4bmPWra2H5VD2d_c2NEQpRJY9mllIhAJQhd3QrV-y2AOsZxOHOjZ4FBBLB_gkkgEYLmLxHh64i8WIrTAL_turWlVhF77gCXNLM_uh-fI'

// {
//   "access_token": "v2.local.4cZ9jVpn7Hf5DrHawATcun0Ia2XE2oBTSxlEy504NIkezFOlTWy8FPoxM541tRmwWsGqeSeTW4Y408Y6XJCIOxoB_VfZVjILVyCftcUdDkzHgh51ouDVGEgkA0G4CeT9YlgJKybihxwKI6uwICAmEPhELF-87BfCEWf4-aG8GAaHxxLQ5q7mOpkBeheyNhnNlWpA1oBo9u_mkk50-rLlBtHNGj0fY2FVv4IHpzpcwzjuhIaxfu4nSmDNT7SnpKF0umNsgaIGYyn3Bf9KOA6ykx-FHvIa",
//   "token_type": "Bearer",
//   "expires_in": 604800,
//   "expires_at": "2025-07-25T04:08:50.711597Z",
//   "user": {
//     "id": "jJkc8qSsffa24rAE",
//     "email": "michael+canlanservice@sportninja.com",
//     "created_at": "2022-05-30T20:39:26+00:00",
//     "updated_at": "2023-05-19T19:59:44+00:00",
//     "validated_at": "2022-05-30T20:39:26+00:00"
//   }
// }
const canlanToken =
  'v2.local.4cZ9jVpn7Hf5DrHawATcun0Ia2XE2oBTSxlEy504NIkezFOlTWy8FPoxM541tRmwWsGqeSeTW4Y408Y6XJCIOxoB_VfZVjILVyCftcUdDkzHgh51ouDVGEgkA0G4CeT9YlgJKybihxwKI6uwICAmEPhELF-87BfCEWf4-aG8GAaHxxLQ5q7mOpkBeheyNhnNlWpA1oBo9u_mkk50-rLlBtHNGj0fY2FVv4IHpzpcwzjuhIaxfu4nSmDNT7SnpKF0umNsgaIGYyn3Bf9KOA6ykx-FHvIa'

export const getIframeToken = () => {
  const parentUrl =
    window.location !== window.parent.location
      ? window?.document?.referrer
      : window?.document?.location?.href

  let isPlanetIce = false
  if (parentUrl && parentUrl.includes('pacificadulthockey.com')) {
    isPlanetIce = true
  }
  return isCanlan ? canlanToken : isPlanetIce ? planetIceToken : carhaToken
}
